import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody } from 'reactstrap';
import DashboardCardIcon from './DashboardCardIcon';

const DashboardMetricCard = ({
  title,
  value,
  subtitle,
  icon,
  iconColor,
  iconBackgroundColor,
  bgColor
}) => {
  return (
    <Card
      style={{
        width: '100%',
        borderRadius: 14,
        border: '1px solid rgba(255, 255, 255, 0.95)',
        background: bgColor,
        boxShadow: '0 8px 16px rgba(30, 42, 53, 0.06)',
        marginBottom: 0,
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <CardBody
        style={{
          padding: '12px 14px 14px',
        }}
      >
        <div className="d-flex flex-column align-items-start">
          <DashboardCardIcon
            icon={icon}
            iconColor={iconColor}
            backgroundColor={iconBackgroundColor}
            className="mb-3"
          />

          <div>
            <h6
              className="mb-2"
              style={{
                color: '#1E2A35',
                fontSize: 13,
                fontWeight: 500,
                lineHeight: 1.15,
              }}
            >
              {title}
            </h6>

            <h3
              className="mb-0"
              style={{
                color: '#1E2A35',
                fontSize: 18,
                fontWeight: 700,
                lineHeight: 1.1,
              }}
            >
              {value}
            </h3>
            {subtitle ? (
              <div className="mt-1" style={{ color: '#6B7280', fontSize: 12 }}>
                {subtitle}
              </div>
            ) : null}
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

DashboardMetricCard.propTypes = {
  title: PropTypes.string,
  value: PropTypes.any,
  subtitle: PropTypes.string,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  iconBackgroundColor: PropTypes.string,
  bgColor: PropTypes.string,
};

DashboardMetricCard.defaultProps = {
  title: '',
  value: '',
  subtitle: '',
  icon: 'bi bi-grid',
  iconColor: '#1E60DD',
  iconBackgroundColor: '#eaf1ff',
  bgColor: '#fff',
};

export default DashboardMetricCard;
